import { Yup } from '@validations';

export const VALIDATION_AREA_SCHEMA = Yup.object().shape({
  areaName: Yup.string().required('COMMON:VALIDATIONS:REQUIRED_FIELD'),
  costCenter: Yup.string(),
});

export const CONFIG_AREA_FIELD = [
  {
    name: 'areaName',
    label: 'CLIENTS:CREATE_AREA:NAME',
    defaultValue: '',
    type: 'string',
  },
  {
    name: 'costCenter',
    label: 'CLIENTS:CREATE_AREA:COST_CENTER',
    defaultValue: '',
    type: 'string',
  },
];
